import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for LiveChatIndicator component customisation
 * Returns styling for the live chat sticky banner
 */
export const useLiveChatIndicatorCustomisation = () => {
  const { getField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT_LIVE_CHAT,
    sectionKey: PUI.CHATBOT_LIVE_CHAT_SECTION_KEYS.LIVE_CHAT_STICKY_BANNER,
    blockKey: PUI.CHATBOT_LIVE_CHAT_BLOCK_KEYS.LIVE_CHAT_STICKY_BANNER,
  });

  const iconColor = getField(PUI.COMMON_FIELD_KEYS.ICON);
  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const endLiveChatIconColor = getField(PUI.COMMON_FIELD_KEYS.END_LIVE_CHAT_ICON_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);

  return {
    iconColor,
    textContent,
    textColor,
    endLiveChatIconColor,
    backgroundColor,
    borderColor,
  };
};
